export enum EnumFileStateWithDispatch {
    Esperando = 1,
    EnProceso = 2,
    Generado = 3,
    ErrorGenerar = 4,
    Enviado = 5,
    ErrorEnviar = 6
  }
  